import React from 'react';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import classnames from 'classnames';
import { browserHistory, Link } from 'react-router';
import axios from 'axios';

import { authenticateUser } from '../../../../../../store/auth';
import Form from '../../../../../../components/Form/Form/';
import FinishedTyping from '../../../../../../components/Form/FinishedTyping';
import Spinner from '../../../../../../components/Spinner';

import './SignupForm.scss';

const RegisterUserMutation = gql`
  mutation (
    $Email: String!
    $TrackUrl: String
  ) {
    createUser(input: {
      email: $Email
      trackUrl: $TrackUrl
    }) {
      token
      user {
        id
      }
    }
  }
`;

class SignupForm extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      validEmail: null,
      currentValues: {},
      error: null,
      loading: false,
    };

    this.submitForm = this.submitForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleOnKey = this.handleOnKey.bind(this);
  }

  validateEmail (email) {
    return new Promise(resolve => {
      if (email === '') {
        resolve(null);
      }

      if (typeof email === 'string') {
        // eslint-disable-next-line
        if(false === new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(email)) {
          resolve(false);
        }

        axios.post(__LaravelDomain + '/api/v04/validator', {
          email: email,
          rules: {
            email: 'email|mailgun_validate|cleantalk_validate'
          }
        }, {
          headers: {
            'Authorization': 'Basic cGFyYWdvbjpvbmU=',
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(data => {
          resolve(true);
        }).catch(err => {
          resolve(false);
        });
      } else {
        resolve(false);
      }
    });
  }

  handleChange (event) {
    this.validateEmail(event.target.value.email).then(wasValid =>
      this.setState({
        validEmail: wasValid,
        currentValues: event.target.value,
        error: null,
      })
    );
  }

  handleOnKey (event) {
    switch (event.keyCode) {
      case 13: // Enter
        event.preventDefault();
        this.submitForm();
        break;
    }
  }

  submitForm () {
    if (this.state.validEmail === false) {
      this.setState({
        error: 'Please enter a valid Email',
      });
      return;
    }

    if (Object.prototype.hasOwnProperty.call(this.state.currentValues, 'email') &&
      this.state.currentValues.email !== '') {
      this.setState({
        error: null,
        loading: true,
      });
      this.validateEmail(this.state.currentValues.email).then(wasValidEmail => {
        if (wasValidEmail) {
          this.props.registerUser({
            variables: {
              Email: this.state.currentValues.email,
              TrackUrl: window.location.href,
            }
          }).then(newUserData => {
            this.props.authenticateUser(newUserData.data.createUser.token);
            browserHistory.push('/company/home');
          }).catch(err => {
            if (Object.prototype.hasOwnProperty.call(err, 'graphQLErrors')) {
              this.setState({
                error: err.graphQLErrors.map(error => error.message).join(', '),
                loading: false,
              });
            }
          });
        }
      });
    } else {
      this.setState({
        error: 'Please enter your email',
      });
    }
  }

  getErrorMessage (err) {
    if (err === 'User already exists') {
      return (
        <p className='error-text'>This email is already registered. <Link to='/company/login'>Login here</Link></p>
      );
    }
    return (
      <p className='error-text'>{err}</p>
    );
  }

  render () {
    return (
      <div className='SignupForm'>
        {(this.state.error === null) ? <p className='error-text'>&nbsp;</p> : this.getErrorMessage(this.state.error)}
        <Form onChange={this.handleChange}>
          <FinishedTyping className={classnames({
            'SignupForm__TextInput': true,
            'SignupForm__TextInput--invalid': (this.state.validEmail === false),
          })} delay={300} onKeyDown={this.handleOnKey} type='text' name='email' placeholder='Email' />
          <span className='SignupForm__SubmitBtn' onClick={this.submitForm}>
            {this.state.loading ? <Spinner className='spinner--white' /> : 'Register'}
          </span>
        </Form>
      </div>
    );
  }
}

const mapDispatchToProps = {
  authenticateUser: authenticateUser,
};

const mapStateToProps = () => ({
});

export default connect(
  mapStateToProps, mapDispatchToProps
)(graphql(RegisterUserMutation, {
  name: 'registerUser'
})(SignupForm));



// WEBPACK FOOTER //
// ./src/routes/company/routes/Landing/components/SignupForm/index.js